export default {
  EPIC_SALESMAN60: true,
  EPIC_SALESMAN45: true,
  EPIC_SALESMAN31: true,
  TASK_HN20_189: true,
  EPIC_LM59: false,
};
